import React, { useEffect, useState } from 'react';
import { IStudent } from './types';
import { groupBy } from 'Utils';

interface IRecommendation {
  game: string;
  reason: string;
}

const GameRecommendations: React.FC<{ games: string[] }> = ({ games }) => (
  <>
    <h5>Games to play</h5>
    <ul>
      {games.map((g, i) => (
        <li key={i}>{g}</li>
      ))}
    </ul>
  </>
);

const StudentCard: React.FC<{ student: IStudent }> = ({ student }) => {
  const [recommendations, setRecommendations] = useState<IRecommendation[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`/api-v2/student/recommendations/${student.studentId}`, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(r => {
        if (!r.ok) throw Error(r.statusText);
        return r;
      })
      .then(r => r.text())
      .then(r => JSON.parse(r))
      .then(r => {
        setRecommendations(r);
        setLoading(false);
      });
  }, [student.studentId]);

  const gamesToPlay = Object.keys(groupBy(recommendations, 'game')).sort();
  const studentPage = `/student/${student.studentId}`;

  return (
    <div className='mb-4 col-sm-12 col-md-6 col-lg-4 col-xl-4'>
      <div className='card w-100 h-100'>
        <div className='card-body'>
          <a href={studentPage}>
            <div className='card-title d-flex align-items-center'>
              <div className='p-1'>
                <img
                  className='rounded-circle'
                  src={
                    student.headshotUrl || '/images/headshot_placeholder.png'
                  }
                  alt=''
                  width='80'
                  height='80'
                />
              </div>
              <h4 className=''>{student.name}</h4>
            </div>
          </a>
          <div className='card-text'>
            {loading
              ? 'Loading...'
              : (gamesToPlay.length > 0 && (
                  <GameRecommendations games={gamesToPlay} />
                )) ||
                'No recommendations'}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentCard;
